document.addEventListener('DOMContentLoaded', function () {
    const sizeSidebar = document.getElementById('size-sidebar');
    const sizeSelector = document.querySelector('.btn-size-selector');
    const closeSidebar = document.querySelector('.size-sidebar-close');
    const sidebarOverlay = document.querySelector('.size-sidebar-overlay');
    const sizeOptions = document.querySelectorAll('.size-option');
    const hiddenSelect = document.querySelector('.size-hidden-select');
    const sizeButtonText = document.querySelector('.select-size-text');
    const sizeTrigger = document.querySelector('.size-selector-trigger');
    const body = document.body;

    // Store the initial button text from page load
    const initialButtonText = sizeButtonText ? sizeButtonText.textContent : 'SELECT SIZE';

    // True only when the sidebar was opened by the add to cart button,
    // so picking a size can complete the add to cart automatically
    let addToCartIntent = false;

    // Only proceed if all required elements exist
    if (!sizeSidebar || !sizeSelector || !hiddenSelect) return;

    /**
     * Get the attribute label for dynamic button text
     */
    function getAttributeLabel() {
        if (sizeTrigger) {
            const attributeName = sizeTrigger.getAttribute('data-attribute');
            // Get the label from the hidden label element
            const labelElement = document.querySelector(`label[for="${attributeName}"]`);
            if (labelElement) {
                return labelElement.textContent.trim();
            }
        }
        return 'SIZE'; // Fallback
    }

    /**
     * Initialize button text based on current selection
     */
    function initializeButtonText() {
        const currentValue = hiddenSelect.value;
        if (currentValue && sizeButtonText) {
            const attributeLabel = getAttributeLabel();
            sizeButtonText.textContent = `${attributeLabel} ${currentValue.toUpperCase()}`;
        }
    }

    // Initialize on page load
    initializeButtonText();

    /**
     * Open the size selection sidebar
     */
    function openSizeSidebar() {
        sizeSidebar.style.display = 'block';
        // Use setTimeout to ensure display is set before adding class for animation
        setTimeout(() => {
            sizeSidebar.classList.add('size-sidebar-open');
            body.classList.add('size-sidebar-active');
        }, 10);
    }

    /**
     * Close the size selection sidebar
     */
    function closeSizeSidebar() {
        addToCartIntent = false;
        sizeSidebar.classList.remove('size-sidebar-open');
        body.classList.remove('size-sidebar-active');
        // Hide after animation completes
        setTimeout(() => {
            sizeSidebar.style.display = 'none';
        }, 300);
    }

    /**
     * Select a size option
     */
    function selectSize(sizeValue, sizeText) {
        // Update hidden select value
        hiddenSelect.value = sizeValue;

        // Update button text to show selected size
        if (sizeButtonText) {
            const attributeLabel = getAttributeLabel();
            sizeButtonText.textContent = `${attributeLabel} ${sizeText.toUpperCase()}`;
        }

        // Update size option states
        sizeOptions.forEach(option => {
            option.classList.remove('selected');
        });

        const selectedOption = document.querySelector(`[data-value="${sizeValue}"]`);
        if (selectedOption) {
            selectedOption.classList.add('selected');
        }
        // Trigger WooCommerce variation change event
        if (hiddenSelect) {
            const shouldAutoAddToCart = addToCartIntent;
            addToCartIntent = false;

            // When the sidebar was opened by the add to cart button, complete
            // the add to cart once WooCommerce resolves the selected variation
            if (shouldAutoAddToCart && window.jQuery && variationForm && addToCartButton) {
                window.jQuery(variationForm).off('found_variation.matatAutoAdd');
                window.jQuery(variationForm).one('found_variation.matatAutoAdd', function () {
                    // WooCommerce enables the button asynchronously after the
                    // variation is resolved, so wait for it (up to 3 seconds)
                    let attempts = 0;
                    const waitForEnabled = setInterval(function () {
                        attempts++;
                        if (!addToCartButton.classList.contains('disabled')) {
                            clearInterval(waitForEnabled);
                            addToCartButton.click();
                        } else if (attempts >= 60) {
                            clearInterval(waitForEnabled);
                        }
                    }, 50);
                });
            }

            const changeEvent = new Event('change', { bubbles: true });
            hiddenSelect.dispatchEvent(changeEvent);
        }

        // Close sidebar after selection
        closeSizeSidebar();
    }

    // Open sidebar when size selector is clicked
    if (sizeSelector) {
        sizeSelector.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            openSizeSidebar();
        });

        // Handle keyboard events for accessibility
        sizeSelector.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
                openSizeSidebar();
            }
        });
    }

    // Close sidebar when close button is clicked
    if (closeSidebar) {
        closeSidebar.addEventListener('click', function () {
            closeSizeSidebar();
        });

        // Handle keyboard events for close button
        closeSidebar.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                closeSizeSidebar();
            }
        });
    }

    // Close sidebar when overlay is clicked
    if (sidebarOverlay) {
        sidebarOverlay.addEventListener('click', function () {
            closeSizeSidebar();
        });
    }

    // Handle size option selection
    sizeOptions.forEach(option => {
        option.addEventListener('click', function (e) {
			if (this.classList.contains('disabled')) {
				return;
			}
			// Handle OOS variations - call the BIS handler directly
			if (this.classList.contains('oos-variation')) {
				e.preventDefault();
				e.stopPropagation();
				const variationId = this.getAttribute('data-variation-id');
				const sizeName = this.getAttribute('data-decoded');
				// Mark as selected visually
				sizeOptions.forEach(opt => opt.classList.remove('selected'));
				this.classList.add('selected');
				// Call the BIS handler if available
				if (typeof window.matatBisHandleOosClick === 'function') {
					window.matatBisHandleOosClick(variationId, sizeName);
				}
				return;
			}
            const sizeValue = this.getAttribute('data-value');
            const sizeText = this.textContent.trim();
            selectSize(sizeValue, sizeText);
        });

        // Handle keyboard events for size options
        option.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
				// Handle OOS variations - call the BIS handler directly
				if (this.classList.contains('oos-variation')) {
					e.stopPropagation();
					const variationId = this.getAttribute('data-variation-id');
					const sizeName = this.getAttribute('data-decoded');
					// Mark as selected visually
					sizeOptions.forEach(opt => opt.classList.remove('selected'));
					this.classList.add('selected');
					// Call the BIS handler if available
					if (typeof window.matatBisHandleOosClick === 'function') {
						window.matatBisHandleOosClick(variationId, sizeName);
					}
					return;
				}
                const sizeValue = this.getAttribute('data-value');
                const sizeText = this.textContent.trim();
                selectSize(sizeValue, sizeText);
            }
        });
    });

    // Close sidebar with Escape key
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && sizeSidebar.classList.contains('size-sidebar-open')) {
            closeSizeSidebar();
        }
    });

    // Prevent clicks inside sidebar content from closing the sidebar
    const sidebarContent = document.querySelector('.size-sidebar-content');
    if (sidebarContent) {
        sidebarContent.addEventListener('click', function (e) {
            e.stopPropagation();
        });
    }

    // Handle WooCommerce reset variations
    const resetButton = document.querySelector('.reset_variations');
    if (resetButton) {
        resetButton.addEventListener('click', function () {
            // Reset size selection
            if (hiddenSelect) {
                hiddenSelect.value = '';
            }

            // Reset button text to initial value
            if (sizeButtonText) {
                sizeButtonText.textContent = initialButtonText;
            }

            // Remove selected state from all options
            sizeOptions.forEach(option => {
                option.classList.remove('selected');
            });
        });
    }

    // Intercept add to cart button click to open size selector if no size is selected
    const addToCartButton = document.querySelector('.single_add_to_cart_button');
    if (addToCartButton) {
        addToCartButton.addEventListener('click', function (e) {
            // Check if size selector exists and no size is selected
            if (hiddenSelect && hiddenSelect.value === '') {
                e.preventDefault();
                e.stopPropagation();

                // Open the size selector sidebar and complete the add to cart
                // automatically once a size is picked
                addToCartIntent = true;
                openSizeSidebar();

                // Prevent WooCommerce from showing its default alert
                return false;
            }
            // If size is selected, allow normal add to cart flow
        });
    }

    // Listen for WooCommerce variation events to sync with other attributes
    const variationForm = document.querySelector('.variations_form');
    if (variationForm) {
        // Handle found variation event
        variationForm.addEventListener('found_variation', function (e) {
            // Variation found, keep current selection if valid
        });

        // Handle reset data event
        variationForm.addEventListener('reset_data', function () {
            // Reset button text to initial value when WooCommerce resets data
            if (sizeButtonText) {
                sizeButtonText.textContent = initialButtonText;
            }

            // Remove selected state from all options
            sizeOptions.forEach(option => {
                option.classList.remove('selected');
            });
        });

        // Handle WooCommerce form validation - intercept before WooCommerce shows alert
        variationForm.addEventListener('submit', function (e) {
            // Check if size selector exists and no size is selected
            if (hiddenSelect && hiddenSelect.value === '') {
                e.preventDefault();
                e.stopPropagation();

                // Open the size selector sidebar and complete the add to cart
                // automatically once a size is picked
                addToCartIntent = true;
                openSizeSidebar();

                return false;
            }
        });
    }
});


document.addEventListener('DOMContentLoaded', function () {
  const openBtn = document.querySelector('.size-guide-link');
  const backBtn = document.querySelector('.back-to-main-pannel');
  const closeBtn = document.querySelector('.size-sidebar-close');
  const sidebarContent = document.querySelector('.size-sidebar-content');

  if (openBtn && sidebarContent) {
    openBtn.addEventListener('click', function () {
      sidebarContent.classList.add('show-sub-pannel');
      sidebarContent.classList.remove('hide-sub-pannel');
    });
  }

  if (backBtn && sidebarContent) {
    backBtn.addEventListener('click', function () {
      sidebarContent.classList.remove('show-sub-pannel');
      sidebarContent.classList.add('hide-sub-pannel');
    });
  }

  if (closeBtn && sidebarContent) {
    closeBtn.addEventListener('click', function () {
      sidebarContent.classList.remove('show-sub-pannel');
      sidebarContent.classList.add('hide-sub-pannel');
    });
  }

  // Close if clicking outside
  document.addEventListener('click', function (event) {
    if (
      sidebarContent &&
      sidebarContent.classList.contains('show-sub-pannel') &&
      !sidebarContent.contains(event.target) &&
      !event.target.closest('.size-guide-link') // allow toggle from button
    ) {
      sidebarContent.classList.remove('show-sub-pannel');
      sidebarContent.classList.add('hide-sub-pannel');
    }
  });
});
